import { linkpickTheme, switchThemeComponent } from '@webapps/styles';

const { params: linkpickParams } = linkpickTheme;

const {
  colors: { black1, black2, grey3, grey4, primary, white },
} = linkpickParams;

const defaultTheme = {
  colors: {
    schoolNameColor: black1,
    schoolAdressColor: black2,
    statusProfilColor: black2,
    jpoColor: white,
    categorieColor: white,
    titleProfilName: white,
    background: white,
    background1: grey4,
    background2: grey3,
    itemColor: black2,
    addressColor: black2,
    titleColor: black1,
    primaryColor: primary,
  },
};

export default switchThemeComponent({
  default: defaultTheme,
});
